module.exports = __webpack_public_path__ + "img/expired-bg.ac2abe68.png";